import { AfterViewInit, Component, Inject, signal } from '@angular/core';
import { EmployeeService } from './employee.service';
import { ActivatedRoute } from '@angular/router';
import { WINDOW } from '@benefitsui/app/lib/tokens/window';

@Component({
  selector: 'app-employee-page',
  templateUrl: './employee-page.component.html',
  styleUrls: ['./employee-page.component.scss'],
  standalone: false
})
export class EmployeePageComponent implements AfterViewInit {

  // :  Data members
  employeeId: string | undefined;
  contractId: string | undefined;
  cardHeader = signal<string>('');

  constructor(
    private route: ActivatedRoute,
    private employeeService: EmployeeService,
    @Inject(WINDOW) private window: Window
  ) {
    this.route.paramMap.subscribe(routeData => {
      this.employeeId = routeData.get('id') ?? undefined;
      this.contractId = routeData.get('contractId') ?? undefined;

      // the details page will set it's own page header.
      // otherwise, do it for the list page here:
      if (!this.isOnDetailsPage) {
        this.setTitle('Search employees');
      }
    });
  }

  setTitle(title: string) {
    this.cardHeader.set(title);
  }

  get isOnDetailsPage() {
    return this.employeeId != null &&
      this.employeeId.length > 0 &&
      this.contractId != null &&
      this.contractId.length > 0;
  }

  get token() {
    return this.employeeService.token;
  }

  scrollToTop() {
    this.window.scrollTo(0, 0);
  }

  ngAfterViewInit() {
    this.scrollToTop();
  }
}
